import React, { useState, useEffect, useRef } from 'react';
import { ScanFace, KeyRound, RefreshCcw } from 'lucide-react';
import { verifyBio, enableBio } from '../../lib/pocketBio';

export const PocketLock = ({ user, onUnlocked, onUsePassword }) => {
  const [state, setState] = useState('idle'); // idle | scanning | success
  const [failed, setFailed] = useState(false);
  const busyRef = useRef(false);

  const scan = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setState('scanning');
    try {
      await verifyBio();
      setState('success');
      setTimeout(onUnlocked, 420);
    } catch {
      setState('idle');
      setFailed(true);
    } finally { busyRef.current = false; }
  };

  // If the passkey was deleted from the phone, verification keeps failing —
  // this creates a brand-new passkey (one Face ID prompt, ONCE) and unlocks.
  const reEnroll = async () => {
    if (busyRef.current) return;
    busyRef.current = true;
    setState('scanning');
    try {
      await enableBio(user);
      setState('success');
      setTimeout(onUnlocked, 420);
    } catch {
      setState('idle');
      setFailed(true);
    } finally { busyRef.current = false; }
  };

  // Auto-trigger Face ID the moment the lock screen appears — no tap needed
  useEffect(() => {
    const t = setTimeout(scan, 350);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`pk-lock ${state === 'scanning' ? 'scanning' : ''} ${state === 'success' ? 'pk-unlock-anim' : ''}`} data-testid="pocket-lock-screen">
      <div className="pk-lock-scanline" />
      <button className="pk-reticle" onClick={scan} style={{ background: 'none', cursor: 'pointer' }} data-testid="pocket-bio-scan-btn">
        <div className="pk-reticle-inner" />
        <div className="pk-reticle-core"><ScanFace size={56} strokeWidth={1.2} /></div>
      </button>
      <div className="pk-lock-title" dir="ltr">POCKET <span className="pk-gold-text">UP</span></div>
      <div className="pk-lock-sub">
        {state === 'scanning' ? 'جارٍ التحقق بـ Face ID…'
          : failed ? 'ما قدرت أتحقق — اضغط الدائرة للمحاولة، أو أعد التفعيل تحت'
            : 'جارٍ طلب Face ID…'}
      </div>
      {failed && (
        <button onClick={reEnroll} data-testid="pocket-bio-reenroll" className="pk-lock-btn">
          <RefreshCcw size={15} /> إعادة تفعيل Face ID (حذفت الـ Passkey؟)
        </button>
      )}
      <button onClick={onUsePassword} data-testid="pocket-lock-use-password" className="pk-lock-link">
        <KeyRound size={14} /> الدخول بكلمة السر بدلًا من ذلك
      </button>
    </div>
  );
};
